import { apiClient } from './ApiClient';

export interface ChecklistItem {
  item_id: string;
  completed: boolean;
  completed_at?: string;
  notes?: string;
}

export interface ChecklistData {
  asset_id: string;
  items: ChecklistItem[];
  created_at?: string;
  updated_at?: string;
}

export const ChecklistService = {
  // Get checklist for a specific asset
  async getAssetChecklist(assetId: string): Promise<ChecklistData> {
    const response = await apiClient.get(`/checklists/${assetId}`);
    return response.data;
  },

  // Save/update checklist for a specific asset
  async saveAssetChecklist(
    checklistData: ChecklistData,
  ): Promise<ChecklistData> {
    const response = await apiClient.post('/checklists', checklistData);
    return response.data;
  },

  // Update a specific checklist item
  async updateChecklistItem(
    assetId: string,
    itemId: string,
    itemData: Partial<ChecklistItem>,
  ): Promise<ChecklistData> {
    const response = await apiClient.put(
      `/api/checklists/${assetId}/items/${itemId}`,
      itemData,
    );
    return response.data;
  },
};
